import { render } from "./InspectionImplementationShop.vue?vue&type=template&id=4c60b2f6"
import script from "./InspectionImplementationShop.vue?vue&type=script&lang=js"
export * from "./InspectionImplementationShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/InspectionImplementationShop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c60b2f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c60b2f6', __exports__)) {
    api.reload('4c60b2f6', __exports__)
  }
  
  module.hot.accept("./InspectionImplementationShop.vue?vue&type=template&id=4c60b2f6", () => {
    api.rerender('4c60b2f6', render)
  })

}


export default __exports__